import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { INotification } from "@src/types/api/notification";

export async function notificationList(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<INotification[]>>> {
  return axios.get(API_ENDPOINTS.NOTIFICATION_LIST, {
    params: qData,
  });
}

export async function updateNotificationStatus(
  data: INotification
): Promise<AxiosResponse<TResponse<INotification>>> {
  return axios.put<TResponse<INotification>>(
    `${API_ENDPOINTS.NOTIFICATION_MARK_ALL_READ}`,
    data
  );
}
